import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import whiteLogo from 'assets/images/nielsen-iq-brandbank-logo-white.png';
import blackLogo from 'assets/images/nielsen-iq-brandbank-logo-black.png';
import { SxProps } from '@mui/system';

export type Props = {
  dark?: boolean;
  sx?: SxProps;
};

const HubLogo = (props: Props): JSX.Element => {
  const { dark, sx } = props;

  return (
    <Box sx={sx}>
      <img
        src={dark ? blackLogo : whiteLogo}
        alt='NielsenIQ Brandbank'
        width={200}
      />
      <Typography
        lineHeight={1}
        sx={{ color: dark ? 'text.primary' : 'common.white' }}
      >
        Client Integration Hub
      </Typography>
    </Box>
  );
};

export default HubLogo;
